<template>
    <section class="practice">
        <vue-snotify></vue-snotify>
        <div class="row">
             <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content p-s-content col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <div class="col-md-12 top-title">
                        <h3>Practice Settings</h3>
                    </div>
                    <div class="row p-b-10" style="margin: 0px !important;">
                        
                        <div class="col-md-12">
                            <div class="row m-4">
                                <form @submit.prevent="updatePractice" method="post" style="width: 100%;">
                                    <div class="row" style="margin: 0 !important;">
                                        <div class="col-md-3 m-b-10">
                                            <img :src="`${$server_url}${practiceData.PracticeLogo}`" alt="Old Image"
                                                class="img-fluid m-b-10" />
                                            <div class="btn btn-primary btn-file">
                                                <i class="fa fa-folder" aria-hidden="true"></i>&nbsp;  
                                                <span class="hidden-xs">Browse …</span>
                                                <input type="file" ref="fileInput" @change="handleFileUpload" />
                                            </div>
                                            <img v-if="imagePreviewUrl" :src="imagePreviewUrl" alt="Image Preview"
                                                class="img-fluid" />
                                            <button v-if="imagePreviewUrl" @click="removeImage">Remove Image</button>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="row">
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label for="PracticeName">Practice Name</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-user"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" v-model="practiceData.PracticeName"
                                                                id="PracticeName" name="PracticeName"
                                                                autocomplete="PracticeName" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group" v-if="loginUser.Status == 'PDC' && loginUser.MemberStatus != 'Suspended'">
                                                        <label for="Status">Status:</label>
                                                        <b-input-group prepend="@">
                                                            <b-form-select id="Status" v-model="loginUser.MemberStatus"
                                                                :options="StatusOptions" value-field="item" text-field="item" required>
                                                            </b-form-select>
                                                            <b-form-invalid-feedback id="input-1-live-feedback">
                                                                This is a required field.
                                                            </b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="Address1">Address</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-globe"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" v-model="practiceData.Address1" id="Address1"
                                                                name="Address1" autocomplete="Address1" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-globe"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" id="Address2" name="Address2"
                                                                autocomplete="Address2" v-model="practiceData.Address2"></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="City">City:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-globe"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" id="City" name="City" autocomplete="City"
                                                                v-model="practiceData.City" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="StateID">State:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-globe"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-select id="StateID" v-model="practiceData.StateID"
                                                                :options="StateOptions" value-field="StateID" text-field="Name" required>
                                                            </b-form-select>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="Zip">Zip:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-globe"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" id="Zip" name="Zip" autocomplete="Zip"
                                                                v-model="practiceData.Zip" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div>
                                                        <button type="submit"
                                                            class="btn btn-primary width-100 m-r-5 btn-xs m-b-10">Save</button>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <label for="Phone1">Office:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-phone"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" id="Phone1" name="Phone1"
                                                                autocomplete="Phone1" v-model="practiceData.Phone1" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="Phone2">Mobile:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-phone"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" id="Phone2" name="Phone2"
                                                                autocomplete="Phone2" v-model="practiceData.Phone2" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="Fax">Fax:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-phone"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input type="text" id="Fax" name="Fax"
                                                                autocomplete="Fax" v-model="practiceData.Fax" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="Email">Email:</label>
                                                        <b-input-group prepend="@">
                                                            <b-form-input type="email" id="Email" name="Email" autocomplete="Email"
                                                                placeholder="Email" v-model="practiceData.Email"
                                                                aria-describedby="input-1-live-feedback"
                                                                label="Email" required></b-form-input>
                                                            <b-form-invalid-feedback id="input-1-live-feedback">
                                                                This is a required field.
                                                            </b-form-invalid-feedback>
                                                            <span class="text-danger" v-if="emailErr != ''">{{ emailErr }}</span>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="URL">Website:</label>
                                                        <b-input-group prepend="@">
                                                            <b-form-input type="text" id="URL" name="URL" autocomplete="URL"
                                                                v-model="practiceData.URL" required></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="PracticeYear">Member since:</label>
                                                        <b-input-group>
                                                            <b-input-group-prepend is-text>
                                                                <i class="fa fa-phone"></i>
                                                            </b-input-group-prepend>
                                                            <b-form-input :disabled="true" type="text" id="PracticeYear"
                                                                name="PracticeYear" autocomplete="PracticeYear"
                                                                v-model="practiceData.PracticeYear"></b-form-input>
                                                        </b-input-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                        <!-- <img :src="`${$server_url}${practiceData.PracticeLogo}`" alt="Old Image"
                                            class="img-fluid m-b-10" /> -->
                                        <!-- <div class="btn btn-primary btn-file">
                                            <i class="glyphicon glyphicon-folder-open"></i>
                                            <span>Browse …</span>
                                            <input type="file" ref="fileInput" @change="handleFileUpload" />
                                        </div> -->
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import { validationMixin } from "vuelidate";
import { required, email  } from "vuelidate/lib/validators";

export default {
    name: "view_user",
    components: {
        practiceSidebar
    },
    mixins: [validationMixin],
    data() {
        return {
            isLoading: false,
            pField: "password",
            loginUser: {},
            emailErr: "",
            imagePreviewUrl: '',
            StateOptions: [],
            PracticeLogo: null,
            allowedPages: [],
            practiceData: {
                PracticeName: "",
                Email: "",
                Image: null,
                Fax: "",
                Phone2: "",
                URL: "",
                Phone1: "",
                City: "",
                Address1: "",
                Address2: "",
            },
            StatusOptions: [
                { item: 'Active' },
                { item: 'Suspend' },
            ],
        }
    },
    validations: {
        practiceData: {
            PracticeName: {
                required,
            },
            Email: {
                required, email
            },
            Address1: {
                required,
            }   
        }
    },
    methods: {
        getStates() {
            this.isLoading = true;
            userAPI.getStates(res => {
                this.StateOptions = res.data.data;
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        },
        getPracticeById() {
            userAPI.getPracticeById({ PracticeID: this.loginUser.PracticeID }, res => {
                console.log(res.data);
                this.practiceData = res.data.data;
            }, err => {
                console.log(err);
            });
        },
        handleFileUpload(event) {
            const file = event.target.files[0];

            // Store the selected file
            this.PracticeLogo = file;

            // Read the file and generate a preview URL
            const reader = new FileReader();
            reader.onload = () => {
                this.imagePreviewUrl = reader.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage() {
            this.imagePreviewUrl = '';
            this.PracticeLogo = null;
            this.$refs.fileInput.value = '';
        },
        updatePractice() {
            this.$v.practiceData.$touch()

            if (this.$v.practiceData.$anyError) {
                return;
            }

            userAPI.updatePractice({ ...this.practiceData, PracticeLogo: this.PracticeLogo },
                res => {
                    this.$showNotification(res.data, "success")
                }, err => {
                    if (err.response.status == 410) {
                        this.emailErr = err.response.data.message.Email[0];
                    }
                })
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user; 
        
        if (user.Status == 'DC' || user.Status == 'CA') {
            this.$router.push({ name: 'user_dashboard' });
        }

        this.getStates()
        this.getPracticeById()
    },
}

</script>

<style>
.form-group .input-group {
    flex-wrap: nowrap;
}
.btn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    text-align: right;
    opacity: 0;
    background: none repeat scroll 0 0 transparent;
    cursor: inherit;
    display: block;
}
.btn-file {
    position: relative;
    overflow: hidden;
}
</style>